var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-checklist-a",
    x1: "50%",
    x2: "50%",
    y1: ".592%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EBEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B2C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-checklist-d",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "-46.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3C7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#12ABFF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "svg-checklist-c",
    width: 64,
    height: 86,
    y: 6,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    id: "svg-checklist-b",
    width: "154.7%",
    height: "140.7%",
    x: "-27.3%",
    y: "-14.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.0588235294 0 0 0 0 0.160784314 0 0 0 0 0.701960784 0 0 0 0.15 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg-checklist-f",
    d: "M6.504 13.22l51.99-.008a2 2 0 0 1 2 1.999l-.011 67.991c0 1.105-.896 2-2 2l-51.99.01a2 2 0 0 1-2-2l.011-67.991c0-1.105.896-2 2-2z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "svg-checklist-e",
    width: "125%",
    height: "119.4%",
    x: "-12.5%",
    y: "-6.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.160945393 0 0 0 0 0.218853065 0 0 0 0 0.340183424 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg-checklist-h",
    d: "M6.493 13.212l51.99.008c1.104.001 2 .896 2 2l.01 67.992a2 2 0 0 1-1.999 2l-51.99-.01c-1.104 0-2-.895-2-2l-.01-67.99a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "svg-checklist-g",
    width: "125%",
    height: "119.4%",
    x: "-12.5%",
    y: "-6.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.160945393 0 0 0 0 0.218853065 0 0 0 0 0.340183424 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "svg-checklist-j",
    width: 56,
    height: 72,
    x: 4,
    y: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "svg-checklist-i",
    width: "125%",
    height: "119.4%",
    x: "-12.5%",
    y: "-6.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.160945393 0 0 0 0 0.218853065 0 0 0 0 0.340183424 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg-checklist-l",
    d: "M15 6h34v8a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3V6z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "svg-checklist-k",
    width: "141.2%",
    height: "227.3%",
    x: "-20.6%",
    y: "-45.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1 0 0 0 0 0.521568627 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg-checklist-m",
    width: "1280%",
    height: "190.8%",
    x: "-590%",
    y: "-45.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.341287364 0 0 0 0 0.179793797 0 0 0 0 0.00373933373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "url(#svg-checklist-a)",
    opacity: 0.501
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 11)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#svg-checklist-b)",
    xlinkHref: "#svg-checklist-c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#svg-checklist-d)",
    xlinkHref: "#svg-checklist-c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(4 32.493 49.212)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#svg-checklist-e)",
    xlinkHref: "#svg-checklist-f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F1F3FF",
    xlinkHref: "#svg-checklist-f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-4 32.493 49.212)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#svg-checklist-g)",
    xlinkHref: "#svg-checklist-h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E0E3F5",
    xlinkHref: "#svg-checklist-h"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#svg-checklist-i)",
    xlinkHref: "#svg-checklist-j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FCFCFF",
    xlinkHref: "#svg-checklist-j"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E4F8",
    d: "M10 41h11c1.038.005 1.92-.606 1.634-1.625a7.39 7.39 0 0 0-4.196-4.798c-.481-.205-.636-.827-.255-1.185a3.739 3.739 0 0 0 1.17-2.729c.001-2.072-1.647-3.761-3.68-3.772-2.034-.01-3.685 1.66-3.686 3.733a3.771 3.771 0 0 0 1.168 2.74c.38.364.223.985-.257 1.184a7.3 7.3 0 0 0-4.2 4.754C8.412 40.315 8.961 40.995 10 41z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#svg-checklist-k)",
    xlinkHref: "#svg-checklist-l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FAB10F",
    xlinkHref: "#svg-checklist-l"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF8500",
    strokeWidth: 3,
    d: "M31.999 6.467c1.982 0 2.424-.183 2.503-.85-.003.03-.001-.362-.003-.72l-.003-.395-.004-.518A2.488 2.488 0 0 0 31.999 1.5a2.488 2.488 0 0 0-2.493 2.484l-.003.51-.002.401c-.002.364 0 .773-.003.746.068.662.47.826 2.501.826z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8500",
    d: "M15 6h34v3H15z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 9,
    y: 48,
    fill: "#00BD7B",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 9,
    y: 65,
    fill: "#E1E4F8",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11.25 53.612a1 1 0 0 0 .002 1.414l2.998 2.992 5.248-5.236a1 1 0 0 0-1.412-1.416l-3.836 3.827-1.586-1.582a1 1 0 0 0-1.414.001z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    x: 26,
    y: 51,
    fill: "#E1E4F8",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    x: 26,
    y: 68,
    fill: "#E1E4F8",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 26,
    y: 57,
    fill: "#E1E4F8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    x: 29,
    y: 30,
    fill: "#E1E4F8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 29,
    y: 38,
    fill: "#E1E4F8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 29,
    y: 34,
    fill: "#E1E4F8",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 26,
    y: 74,
    fill: "#E1E4F8",
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-checklist-m)",
    transform: "rotate(45 -19.847 157.52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAB10F",
    d: "M2.157 1.258a2 2 0 0 1 2 2v57h-4v-57a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.128 57.876h4v2.167c-.667 3.222-1.334 4.833-2 4.833-.667 0-1.334-1.611-2-4.833v-2.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69758B",
    d: "M3.698 61.898c-.524 1.985-1.047 2.978-1.57 2.978-.52 0-1.039-.977-1.558-2.932-.147-.555 3.27-.59 3.128-.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF647F",
    d: "M2.128.876a2 2 0 0 1 2 2v3h-4v-3a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M.128 5.876h4v2h-4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.a2ca624694d57aa5cd7efefc1f55b7a4.svg";
export { ForwardRef as ReactComponent };